import { useQuery } from 'react-query';

import {
  getUserAuthenticationFactors,
  type GetUserAuthenticationFactorsInput,
} from '../api/getUserAuthenticationFactors';

export const useGetUserAuthenticationFactors = ({
  userId,
  companyId,
}: GetUserAuthenticationFactorsInput) => {
  return useQuery(['userAuthenticationFactors', companyId, userId], () =>
    getUserAuthenticationFactors({
      userId,
      companyId,
    }),
  );
};
